import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e59628f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "columns mb-0" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "column horizontal mb-4" }, [
        /*#__PURE__*/ _createElementVNode("div", null, [
            /*#__PURE__*/ _createElementVNode("h1", { class: "subtitle mb-4" }, "Inbound Mail"),
            /*#__PURE__*/ _createElementVNode("h3", { class: "mt-2 mb-4" }, "Mailbox for all received mail")
        ])
    ])
], -1));
const _hoisted_2 = { key: 1 };
const _hoisted_3 = {
    class: "column p-0 pb-5",
    style: { "flex-grow": "0.65" }
};
const _hoisted_4 = { class: "tabs is-boxed is-small mb-4" };
const _hoisted_5 = { class: "is-active" };
const _hoisted_6 = { style: { "cursor": "default" } };
const _hoisted_7 = { style: { "min-height": "6rem" } };
const _hoisted_8 = {
    key: 0,
    class: "noneFound ml-4"
};
const _hoisted_9 = {
    key: 1,
    style: { "text-align": "center" }
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tabs is-boxed is-small mb-4 mt-5" }, [
    /*#__PURE__*/ _createElementVNode("ul", null, [
        /*#__PURE__*/ _createElementVNode("li", { class: "is-active" }, [
            /*#__PURE__*/ _createElementVNode("a", { style: { "cursor": "default" } }, [
                /*#__PURE__*/ _createElementVNode("strong", null, "Forwarded Mail")
            ])
        ])
    ])
], -1));
const _hoisted_11 = { style: { "min-height": "6rem" } };
const _hoisted_12 = {
    key: 0,
    class: "noneFound ml-4"
};
const _hoisted_13 = {
    key: 1,
    style: { "text-align": "center" }
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tabs is-boxed is-small mb-4 mt-5" }, [
    /*#__PURE__*/ _createElementVNode("ul", null, [
        /*#__PURE__*/ _createElementVNode("li", { class: "is-active" }, [
            /*#__PURE__*/ _createElementVNode("a", { style: { "cursor": "default" } }, [
                /*#__PURE__*/ _createElementVNode("strong", null, "Trashed Mail")
            ])
        ])
    ])
], -1));
const _hoisted_15 = { style: { "min-height": "6rem" } };
const _hoisted_16 = {
    key: 0,
    class: "noneFound ml-4"
};
const _hoisted_17 = {
    key: 1,
    style: { "text-align": "center" }
};
const _hoisted_18 = {
    key: 0,
    class: "column p-0"
};
const _hoisted_19 = {
    key: 0,
    class: "box noItemHighlightedPanel p-3"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("article", { class: "media" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "media-content" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "content" }, [
            /*#__PURE__*/ _createElementVNode("div", null, "Select a mail item on the left to view detail")
        ])
    ])
], -1));
const _hoisted_21 = [
    _hoisted_20
];
import { onMounted, onUnmounted, ref, computed } from "vue";
import InboundMailItemWidget from "./InboundMailItemWidget.vue";
import InboundMailItemDetailPanel from "./InboundMailItemDetailPanel.vue";
import { useAsync } from "@/composables/useAsync";
import { InboundMailItemStatus } from "./model";
import { apiInboundMail } from "./api";
const LIMIT_SIZE = 6;
export default /*#__PURE__*/ _defineComponent({
    __name: 'InboundMailListingPanel',
    setup(__props) {
        const props = __props;
        const items = useAsync();
        const highlightedItem = ref(null);
        const detailOffset = ref(0);
        const itemListingWrapper = ref(null);
        const compareItems = (a, b) => {
            return b.receivedAt - a.receivedAt;
        };
        const expandUnprocessedItems = ref(false);
        const unprocessedItems = computed(() => {
            if (items.status != 'ready')
                return [];
            const sorted = items.data.filter(item => {
                return item.status == InboundMailItemStatus.RECEIVED;
            });
            return sorted.sort(compareItems);
        });
        const expandForwardedItems = ref(false);
        const forwardedItems = computed(() => {
            if (items.status != 'ready')
                return [];
            const sorted = items.data.filter(item => {
                return item.status == InboundMailItemStatus.FORWARDED;
            });
            return sorted.sort(compareItems);
        });
        const expandTrashedItems = ref(false);
        const trashedItems = computed(() => {
            if (items.status != 'ready')
                return [];
            const sorted = items.data.filter(item => {
                return item.status == InboundMailItemStatus.TRASHED;
            });
            return sorted.sort(compareItems);
        });
        const highlightItem = (item, elem) => {
            highlightedItem.value = item;
            // Determine offset for detail panel so it aligns vertically
            while (!elem.classList.contains("itemWidget")) {
                if (!elem.parentElement)
                    break;
                elem = elem.parentElement;
            }
            detailOffset.value = elem.offsetTop - itemListingWrapper.value.offsetTop;
            // Update URL query params, so if the user shares a link while a task is highlighted, we can restore it
            const url = new URL(window.location.toString());
            if (item) {
                url.searchParams.set('itemId', item.id);
            }
            else {
                url.searchParams.delete('itemId');
            }
            window.history.replaceState({}, '', url);
        };
        onMounted(() => {
            items.fetch(apiInboundMail.getItems(), "Failed to load items")
                .then((items) => {
                // Pre-select a task, if the '?itemId=xxx' query parameter is set
                const url = new URL(window.location.toString());
                if (!url.searchParams.has('itemId'))
                    return;
                const itemId = url.searchParams.get('itemId');
                for (let item of items) {
                    if (item.id == itemId) {
                        highlightedItem.value = item;
                        return;
                    }
                }
            });
        });
        onUnmounted(() => {
            // Clear itemId query param
            const url = new URL(window.location.toString());
            if (url.searchParams.has('itemId')) {
                url.searchParams.delete('itemId');
                window.history.replaceState({}, '', url);
            }
        });
        const onItemUpdated = (item) => {
            var _a;
            // When highlighted item is modified by InboundMailItemDetailPanel, a new object is returned.
            // We need to overwrite the same task in the task list with the updated reference...
            if (((_a = highlightedItem.value) === null || _a === void 0 ? void 0 : _a.id) == item.id) {
                highlightedItem.value = item;
            }
            for (let i = 0; i < items.data.length; ++i) {
                if (items.data[i].id == item.id) {
                    items.data[i] = item;
                }
            }
        };
        return (_ctx, _cache) => {
            const _component_LoadingSpinner = _resolveComponent("LoadingSpinner");
            return (_openBlock(), _createElementBlock("div", null, [
                _hoisted_1,
                (_unref(items).status == 'loading')
                    ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                    : (_unref(items).status == 'ready')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", {
                                class: "columns is-mobile",
                                ref_key: "itemListingWrapper",
                                ref: itemListingWrapper
                            }, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", _hoisted_5, [
                                                _createElementVNode("a", _hoisted_6, [
                                                    _createElementVNode("strong", null, "Unprocessed Mail (" + _toDisplayString(unprocessedItems.value.length) + ")", 1)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        (unprocessedItems.value.length == 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "No Unprocessed Mail"))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expandUnprocessedItems.value ? unprocessedItems.value : unprocessedItems.value.slice(0, LIMIT_SIZE), (item) => {
                                            var _a;
                                            return (_openBlock(), _createBlock(InboundMailItemWidget, {
                                                key: item.id,
                                                item: item,
                                                highlighted: item.id == ((_a = highlightedItem.value) === null || _a === void 0 ? void 0 : _a.id),
                                                onClick: ($event) => (highlightItem(item, $event.target))
                                            }, null, 8, ["item", "highlighted", "onClick"]));
                                        }), 128)),
                                        (!expandUnprocessedItems.value && unprocessedItems.value.length > LIMIT_SIZE)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                _createElementVNode("a", {
                                                    onClick: _cache[0] || (_cache[0] = ($event) => (expandUnprocessedItems.value = true))
                                                }, "Show All (" + _toDisplayString(unprocessedItems.value.length - LIMIT_SIZE) + " more)", 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _hoisted_10,
                                    _createElementVNode("div", _hoisted_11, [
                                        (forwardedItems.value.length == 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "No Forwarded Mail"))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expandForwardedItems.value ? forwardedItems.value : forwardedItems.value.slice(0, LIMIT_SIZE), (item) => {
                                            var _a;
                                            return (_openBlock(), _createBlock(InboundMailItemWidget, {
                                                key: item.id,
                                                item: item,
                                                highlighted: item.id == ((_a = highlightedItem.value) === null || _a === void 0 ? void 0 : _a.id),
                                                onClick: ($event) => (highlightItem(item, $event.target))
                                            }, null, 8, ["item", "highlighted", "onClick"]));
                                        }), 128)),
                                        (!expandForwardedItems.value && forwardedItems.value.length > LIMIT_SIZE)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                _createElementVNode("a", {
                                                    onClick: _cache[1] || (_cache[1] = ($event) => (expandForwardedItems.value = true))
                                                }, "Show All (" + _toDisplayString(forwardedItems.value.length - LIMIT_SIZE) + " more)", 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _hoisted_14,
                                    _createElementVNode("div", _hoisted_15, [
                                        (trashedItems.value.length == 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, "No Trashed Mail"))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expandTrashedItems.value ? trashedItems.value : trashedItems.value.slice(0, LIMIT_SIZE), (item) => {
                                            var _a;
                                            return (_openBlock(), _createBlock(InboundMailItemWidget, {
                                                key: item.id,
                                                item: item,
                                                highlighted: item.id == ((_a = highlightedItem.value) === null || _a === void 0 ? void 0 : _a.id),
                                                onClick: ($event) => (highlightItem(item, $event.target))
                                            }, null, 8, ["item", "highlighted", "onClick"]));
                                        }), 128)),
                                        (!expandTrashedItems.value && trashedItems.value.length > LIMIT_SIZE)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _createElementVNode("a", {
                                                    onClick: _cache[2] || (_cache[2] = ($event) => (expandTrashedItems.value = true))
                                                }, "Show All (" + _toDisplayString(trashedItems.value.length - LIMIT_SIZE) + " more)", 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                (unprocessedItems.value.length + forwardedItems.value.length + trashedItems.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        (highlightedItem.value == null)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                style: _normalizeStyle({ 'padding-top': `${detailOffset.value}px` }),
                                                class: "pb-3"
                                            }, [
                                                (_openBlock(), _createBlock(InboundMailItemDetailPanel, {
                                                    item: highlightedItem.value,
                                                    key: highlightedItem.value.id,
                                                    onItemUpdated: _cache[3] || (_cache[3] = ($event) => (onItemUpdated($event)))
                                                }, null, 8, ["item"]))
                                            ], 4))
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 512)
                        ]))
                        : _createCommentVNode("", true)
            ]));
        };
    }
});
